import React from 'react';
import ButtonGroupNew from '../BusinessLiteForms/components/ButtonGroupNew';
import "../IndividualLite.scss";
import BusinessPlusIntro from './BusinessPlusIntro';

const BusinessPlusIntroductionV2 = ({
    asLabel,
    hideButtons,
    loading,
    onNext,
    v2Type,
}) => (
    <div>
        <BusinessPlusIntro v2Type={v2Type} />

        <div className='mt-4'>
            <ButtonGroupNew
                onNextClick={onNext}
                onBackClick={() => { }}
                step={1}
                hideBackButton
                showPageNum
                pageNum={1}
                isDisabled={asLabel}
                asLabel={hideButtons}
                loading={loading}
            />
        </div>
    </div>
);

export default BusinessPlusIntroductionV2;
